export default {
    data() {
        return {
            alert: "",
            alertType: "success"
        }
    },
    methods: {
        setAlert(data) {
            if (data.ok) {
                this.alertType = "success"
                this.alert = data.message
            } else {
                this.alertType = "error"
                this.alert = data.error || "Request Failed"
            }
        },
        resetAlert() {
            this.alert = ""
        }
    }
}